<!-- Label Input, cuando no se requiere enviar variable offLabel: true -->
@if (!offLabel) {
  <label class="efx-label" [for]="structInput?.name" >
    {{ structInput?.label }}
  </label>
}

<!-- Container que despliega template de input -->
@switch (structInput?.inputType) {
  @case ('text') {
    <section>
      <ng-container *ngTemplateOutlet="text"></ng-container>
    </section>
  }
  @case ('number') {
    <section>
      <ng-container *ngTemplateOutlet="number"></ng-container>
    </section>
  }
  @case ('email') {
    <section>
      <ng-container *ngTemplateOutlet="email"></ng-container>
    </section>
  }
  @case ('checkbox') {
    <section>
      <ng-container *ngTemplateOutlet="checkbox"></ng-container>
    </section>
  }
  @case ('select') {
    <section>
      <ng-container *ngTemplateOutlet="select"></ng-container>
    </section>
  }
  @case ('date') {
    <section>
      <ng-container *ngTemplateOutlet="date"></ng-container>
    </section>
  }
  @case ('textarea') {
    <section>
      <ng-container *ngTemplateOutlet="textarea"></ng-container>
    </section>
  }
}


<!-- Contenedor para tipos de calendario -->
<ng-template #date>
  @if (structInput?.pattern === 'YYYYMM' ) {
    <input
      class="efx-input"
      type="month"
      [id]="structInput?.name"
      [name]="structInput?.name"
      [formControl]="formControlador"
      [ngClass]="{ 'is-invalid': formControlador?.invalid }"
      />
    }

    @if (structInput?.pattern === 'DDMMAAAA' || structInput?.pattern === 'AAAAMMDD') {
      <input
        class="efx-input"
        type="date"
        [id]="structInput?.name"
        [name]="structInput?.name"
        [formControl]="formControlador"
        [ngClass]="{ 'is-invalid': formControlador?.invalid }"
        />
      }

    </ng-template>

    <!-- Contenedor para tipos de select -->
    <ng-template #select>
      <select
        class="efx-input"
        [ngClass]="{ 'is-invalid': formControlador.invalid }"
        [formControl]="formControlador"
        >
        @for (option of structInput.value; track option) {
          <option
            [value]="option.value"
            >
            {{ option.text }}
          </option>
        }
      </select>
    </ng-template>

    <!-- Contenedir para distintos tipos de inputs, para personalizar alguno generar nuevo ng-template -->
    <ng-template #text #number #email>
      <input
        class="efx-input"
        [formControl]="formControlador"
        [id]="structInput.name"
        [name]="structInput.name"
        [type]="structInput.inputType"

        [min]="validators.min"
        [max]="validators.max"
        [minlength]="validators.minlength"
        [maxlength]="validators.maxlength"
        [ngClass]="{ 'is-invalid': formControlador.invalid }"
        />
      </ng-template>

      <!-- Contenedir para checkbox -->
      <ng-template #checkbox>
        <input
          class="efx-checkbox"
          type="checkbox"
          [id]="structInput.name"
          [name]="structInput.name"
          [checked]="structInput.value"
          [formControl]="formControlador"
          [ngClass]="{ 'is-invalid': formControlador.invalid }"
          />

        </ng-template>

        <!-- Contenedor para tipos de textarea -->
        <ng-template #textarea>
          <textarea
            type="text"
            style="resize: both; overflow: auto;"
            [formControl]="formControlador"
            [id]="structInput.name"
            [name]="structInput.name"
            [ngClass]="{ 'is-invalid': formControlador.invalid }"
            >
          </textarea>
        </ng-template>
